import { Badge, Button, Checkbox, EmptyState } from '@/components/ui';

import { formatDate } from '@/utils/format';

/**
 * Who the next handover would carry, and the chance to send only some of them.
 *
 * Nothing is ticked to begin with, and an empty selection means everyone —
 * which is what the API reads an empty list as. That way the ordinary case is
 * one button and the exception is still available, rather than making a
 * recruiter tick forty boxes to do the obvious thing.
 */
export function PendingCandidates({ candidates, selected, onToggle, onClear }) {
  if (!candidates.length) {
    return (
      <EmptyState
        title="Nobody is waiting"
        description="Everyone who has reached the stage you chose has already been handed over."
      />
    );
  }

  return (
    <div>
      <div className="text-ink-muted mb-3 flex items-center justify-between gap-3 text-sm">
        <span>
          {selected.length
            ? `${selected.length} of ${candidates.length} chosen`
            : `${candidates.length} waiting — all of them will be sent`}
        </span>
        {selected.length > 0 && (
          <Button variant="ghost" size="sm" onClick={onClear}>
            Send everyone instead
          </Button>
        )}
      </div>

      <ul className="divide-line divide-y">
        {candidates.map((candidate) => (
          <li key={candidate.application_id} className="flex items-center gap-3 py-3">
            <Checkbox
              checked={selected.includes(candidate.application_id)}
              onChange={() => onToggle(candidate.application_id)}
              label=""
            />
            <div className="min-w-0 flex-1">
              <p className="text-ink truncate text-sm font-medium">{candidate.candidate_name}</p>
              <p className="text-ink-muted truncate text-xs">
                {candidate.role_title} · applied {formatDate(candidate.applied_at)}
              </p>
            </div>
            <Badge tone="neutral">{candidate.stage.replace('_', ' ')}</Badge>
            {candidate.match_score !== null && candidate.match_score !== undefined && (
              <span className="text-ink-muted w-12 text-right text-xs">
                {Math.round(candidate.match_score)}%
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
